import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { TransactionDetails } from "@/components/transactions/details"
import { FRONTEND_ROUTES } from "@/constants"

export function ScheduleDetailsPage() {
  const { t } = useTranslation()
  const { transactionId } = useParams<{
    transactionId: string
  }>()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.SCHEDULE.href,
              label: t("sidebar.schedule"),
            },
            {
              label: t("common.details"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <TransactionDetails
          transactionId={transactionId || ""}
        />
      </section>
    </DashboardContainer>
  )
}
